import { ReservationContractTemplateFileFieldMappingStatus } from '@mews-commander/data-access';
import { TooltippedHighlightIcon } from '@mews-commander/ui';
import { IconName } from '@optimus-web/icons';
import { lt } from '@mews/framework';

export const FieldStatusIcon = ({
    fieldStatus,
}: {
    fieldStatus?: ReservationContractTemplateFileFieldMappingStatus;
}) => {
    if (
        fieldStatus == null ||
        fieldStatus === ReservationContractTemplateFileFieldMappingStatus.UpToDate ||
        fieldStatus === ReservationContractTemplateFileFieldMappingStatus.Removed
    ) {
        return null;
    }
    return (
        <TooltippedHighlightIcon
            size="small"
            iconVariant="basic"
            value={IconName.AlertCircle}
            tooltip={
                fieldStatus === ReservationContractTemplateFileFieldMappingStatus.New
                    ? lt('ContractTemplateFieldStatusNewTooltip')
                    : lt('ContractTemplateFieldStatusModifiedTooltip')
            }
        />
    );
};
